var editorsupport = require('../../../../web/ui/js/editorsupport');
require('./docs.scss');
var toddImages = require('../../../../web/ui/js/images');/// toddImages

var domscroll = require('@webhare-system/dom/scroll');
var moo = require('@webhare-system/frameworks/mootools/core');
var $=moo.$;

var currenttab;
var currentpage;

function docinit()
{
  document.addEvent("click:relay(a)", gotLinkClick);
  document.addEvent("click", gotFoldableMouseDown);

  if (location.hash)
  {
    var target = unfoldHashTarget(location.hash.substr(1));
    if (target)
    {
      target = target.getSelfOrParent(".foldable");

      // Scroll to element, make sure a lot of stuff below is visible
      domscroll.scrollToElement(target, { context: "20px 0 1000px" });
    }
  }

  // FIXME: this seems to simulate hash navigation?? (except without keyboard support)
  Array.each( document.querySelectorAll("h3[data-tabid]"), function(node, index, all){
      var tabid = node.getAttribute("data-tabid");
      var tabelem = $(tabid);
      /// Add proper click handlers for tab switching:
      if(node.hasClass("selected"))
      {
        currenttab = node;
        currentpage = tabelem;
      }

      node.addEvent("click", function(event){
        var elem = event.target;
        var tabelem = $(event.target.getAttribute("data-tabid"));
        if(elem.hasClass("selected"))
          return; // do nothing
        elem.classList.add("selected");
        currenttab.classList.remove("selected");
        currenttab = elem;
        //console.log(tabelem.id);
        tabelem.classList.add("active");
        currentpage.classList.remove("active");
        currentpage = tabelem;
      });
      //console.log(node, tabid, tabelem);
    });

  Array.each( document.querySelectorAll("img.ixo,img.svg"), function(node, index, all){
    var img = toddImages.createImage(node.getAttribute("data-fqn"), parseInt(node.getAttribute("data-size")), parseInt(node.getAttribute("data-size")), node.getAttribute("data-color"));
    img.setAttribute("id", node.getAttribute("id"));
    img.setAttribute("title", node.getAttribute("title"));
    img.setAttribute("alt", node.getAttribute("alt"));
    img.setAttribute("class", node.getAttribute("class"));
    img.setAttribute("data-fqn", node.getAttribute("data-fqn"));
    img.setAttribute("data-size", node.getAttribute("data-size"));
    img.setAttribute("data-color", node.getAttribute("data-color"));
    node.parentNode.replaceChild(img, node);
  });

  Array.each( document.querySelectorAll("img.nocheck"), function(node, index, all){
    var img = toddImages.createImage(node.getAttribute("data-fqn"), parseInt(node.getAttribute("data-size")), parseInt(node.getAttribute("data-size")), node.getAttribute("data-color"));
    img.setAttribute("id", node.getAttribute("id"));
    img.setAttribute("title", node.getAttribute("title"));
    img.setAttribute("alt", node.getAttribute("alt"));
    img.setAttribute("class", node.getAttribute("class"));
    img.setAttribute("data-fqn", node.getAttribute("data-fqn"));
    img.setAttribute("data-size", node.getAttribute("data-size"));
    img.setAttribute("data-color", node.getAttribute("data-color"));
    node.parentNode.replaceChild(img, node);
  });
}

function unfoldHashTarget(hash)
{
  // Unfold the target
  if (hash)
  {
    var target = $(hash);
    if (target)
    {
      //console.log(target.firstElementChild.innerHTML);

      // FIXME: unholy code, it's very mysterious and doesn't work... anymore..
      if(target.firstElementChild && target.firstElementChild.innerHTML.indexOf(":") != -1)
      {
        $("symbol").setAttribute("href", "#" + target.getAttribute("id"));
        $("symbol").innerHTML = "Library";
      }
      else if(target.firstElementChild)
      {
        $("symbol").setAttribute("href", "#" + target.getAttribute("id"));
        $("symbol").innerHTML = target.firstElementChild.innerHTML;
      }
      var folded = target.getParents(".foldable.folded");
      folded.classList.remove("folded");
      return target;
    }
  }
}

function gotLinkClick(event, node)
{
  if(node.getAttribute("class") == "actionlink")
  {
    if(node.getAttribute("data-icon") == "sublime")
    {
      doOpenInSublime(node);
    }
    else if(node.getAttribute("data-icon") == "finder")
    {
      doRevealInFinder(node);
    }
    return;
  }
  var hash = node.href.match(/#(.*)/)[1];
  unfoldHashTarget(hash);
}


function gotFoldableMouseDown(event)
{
  var clicknode;
  var foldablenode = event.target.getSelfOrParent(".foldable");
  if (!foldablenode)
    return;

  console.log('foldablenode', foldablenode);
  switch (foldablenode.nodeName.toLowerCase())
  {
  case "div": { clicknode = foldablenode.firstElementChild; break; }
  case "dt":  { clicknode = foldablenode; break; }
  default:    { return; }
  }

  var node = event.target;
  while (node && node != clicknode)
    node = node.parentNode;

  if (!node)
    return;

  foldablenode.toggleClass("folded");
  event.stop();
}

function doOpenInSublime(node)
{
  var parts = node.getAttribute("data-sourcepath").split(/([A-Za-z:.-\/]+)\:(\d+)\:(\d+)/);
  editorsupport.openInSublime(parts[1], parseInt(parts[2]), parseInt(parts[3]));
}

function doRevealInFinder(node)
{
  editorsupport.revealInFinder(node.getAttribute("data-sourcepath"));
}

module.exports = { onReady: docinit };



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/modules/tollium/webdesigns/webinterface/pages/docs/docs.js
// module id = 1170
// module chunks = 0